<template>
  <div>
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Create Employee Attendance</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3" md="3">
            <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="ay"
              :items="ay_list"
              item-text="ay"
              item-value="id"
              label="Academic Year"
              outlined
              persistent-hint
              hint="Please Select Academic Year"
            />
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <p><v-icon color="error">*</v-icon><b>Employee</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="emp"
              :items="emp_list"
              item-text="name"
              item-value="id"
              label="Employee"
              outlined
              persistent-hint
              hint="Please Select Employee"
            />
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <p><v-icon color="error">*</v-icon><b>Employee Type</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="emp_type"
              :items="emp_type_list"
              item-text="name"
              item-value="id"
              label="Employee Type"
              outlined
              persistent-hint
              hint="Please Select Employee Type"
            />
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <p><v-icon color="error">*</v-icon><b>Employee Designation</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="designation"
              :items="designation_list"
              item-text="name"
              item-value="id"
              label="Employee Designation"
              outlined
              persistent-hint
              hint="Please Select Employee Designation"
            />
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <p><v-icon color="error">*</v-icon><b>Employee Section</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="section"
              :items="emp_section_list"
              item-text="name"
              item-value="id"
              label="Employee Section"
              outlined
              persistent-hint
              hint="Please Select Employee Section"
            />
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <p><v-icon color="error">*</v-icon><b>Employee Shift</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="shift"
              :items="emp_shift_list"
              item-text="name"
              item-value="id"
              label="Employee Shift"
              outlined
              persistent-hint
              hint="Please Select Employee Shift"
            />
          </v-col>
          <v-col cols="12" sm="3" md="3" class="pt-4 mt-5" v-if="ay != null">
            <v-btn class="button" @click="getEmpDeatils()">Fetch</v-btn>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="box" v-if="inst_details != ''">
        <v-row dense justify="center" v-if="inst_details != ''">
          <v-col cols="12" sm="3" md="3">
            <p><v-icon color="error">*</v-icon><b>From Date</b></p>
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-bind="attrs"
                  dense
                  v-model="date_of_generation"
                  @blur="date = parseDate(date_of_generation)"
                  v-on="on"
                  hint="From Date"
                  prepend-icon="event"
                  outlined
                  rounded
                  persistent-hint
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="gen_date"
                no-title
                @input="menu1 = false"
              ></v-date-picker>
            </v-menu>
            <!-- <input id="datePickerId" type="date" v-model="date_2" /> -->
          </v-col>

          <v-col cols="12" sm="3" md="3">
            <p><v-icon color="error">*</v-icon><b>To Date</b></p>
            <v-menu
              ref="menu2"
              v-model="menu2"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-bind="attrs"
                  dense
                  v-model="application_date"
                  v-on="on"
                  hint="To Date"
                  outlined
                  rounded
                  prepend-icon="event"
                  persistent-hint
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date_of_application"
                no-title
                @input="menu2 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3" md="3" class="pt-4 mt-5" v-if="ay != null">
            <v-btn class="button" @click="addAttendance()"
              >Add Attendance</v-btn
            >
          </v-col>
        </v-row>
        <v-row dense v-if="inst_details != ''">
          <!-- <v-col cols="12" sm="6" md="6">
                    <v-btn rounded color="success" outlined @click="fnExcelReport('my-table-id', 'BlockUnblockResult')" :loading="loader"> <v-icon color="success">mdi-export</v-icon>Export </v-btn>
                </v-col> -->
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="search1"
              append-icon="mdi-magnify"
              label="Search by Employee Name or by Employee Code"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <v-col cols="12" sm="12" md="12" v-if="inst_details != ''">
          <!-- <strong> Note: If checked then its block student and if unchecked its unblock student</strong> -->
          <div id="my-table-id">
            <v-simple-table
              fixed-header
              dense
              class="elevation-1"
              height="500px"
            >
              <thead>
                <tr>
                  <th align="center">
                    <label class="form-checkbox">
                      <input
                        type="checkbox"
                        v-model="selectAll"
                        @click="select()"
                      />
                      <i class="form-icon"></i>
                    </label>
                  </th>
                  <th class="">Sr. No.</th>
                  <th class="">Name</th>
                  <th class="">Employee Designation</th>
                  <th class="">Employee Type</th>
                  <th class="">Employee Section</th>
                  <th class="">Date Of Joining</th>
                </tr>
              </thead>
              <tbody>
                <tr></tr>
                <tr v-for="(s, index) in filteredItems" :key="s.instid">
                  <td>
                    <label class="form-checkbox">
                      <input
                        type="checkbox"
                        :value="s.instid"
                        v-model="s.inst_select"
                      />
                      <i class="form-icon"></i>
                    </label>
                  </td>
                  <td>{{ index + 1 }}</td>
                  <td>{{ s.name }}</td>
                  <td>{{ s.inst_designation }}</td>
                  <td>{{ s.inst_employeetype }}</td>
                  <td>{{ s.inst_employeesection }}</td>
                  <td>{{ s.inst_date_of_joining }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
        </v-col>
      </v-card>
    </v-container>
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Holiday from "../Admin/Holiday";
export default {
  components: {
    holiday: Holiday,
  },
  data: () => ({
    loader: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
    ay_list: [],
    ay: "",
    // headers: [
    //     { text: "Sr.No.", value: "srno", class: "my-header-style" },
    //     {
    //         text: "Holiday Name",
    //         value: "holiday",
    //         class: "my-header-style",
    //     },
    //     {
    //         text: "Academic Year",
    //         value: "academicyear",
    //         class: "my-header-style",
    //     },
    //     { text: "Holiday Date", value: "date", class: "my-header-style" },
    //     { text: "Day", value: "day", class: "my-header-style" },
    //     { text: "Month", value: "month", class: "my-header-style" },
    //     { text: "Year", value: "year" ,class: "my-header-style"},
    //     { text: "Status", value: "isactive" ,class: "my-header-style"},
    //     { text: "Actions", value: "action", class: "my-header-style"},
    // ],
    emp_type_list: [],
    emp_type: null,
    designation_list: [],
    designation: null,
    emp_section_list: [],
    emp_shift_list: [],
    section: null,
    shift: null,
    emp_list: [],
    emp: null,
    inst_details: [],
    selected: [],
    selectAll: false,
    search1: "",
    date: new Date().toISOString().slice(0, 10),
    menu1: false,
    menu2: false,
    menu11: false,
    todate: null,
    nowDate: new Date().toISOString().slice(0, 10),
    date_1: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    modal_1: false,
    date_2: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1)
      .toISOString()
      .substr(0, 10),

    //
    date_of_generation: "",
    gen_date: new Date().toISOString().substr(0, 10),
    date_of_application: new Date(
      new Date().getFullYear(),
      new Date().getMonth() + 1,
      1
    )
      .toISOString()
      .substr(0, 10),
    application_date: "",
  }),
  watch: {
    gen_date(val) {
      this.date_of_generation = this.formatDate(this.gen_date);
    },
    date_of_application(val) {
      this.application_date = this.formatDate(this.date_of_application);
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    select() {
      this.selected = [];
      for (let i in this.inst_details) {
        this.inst_details[i].inst_select = false;
      }
      if (!this.selectAll) {
        for (let i in this.inst_details) {
          this.selected.push(this.inst_details[i].instid);
          this.inst_details[i].inst_select = true;
        }
      }
    },
    addAttendance() {
      // if(this.selected == '' || this.selected == null){
      //     this.showSnackbar("red", "Please select atleast one employee !!");
      //     return
      // }
      const data = {
        ay: this.ay,
        selected: this.inst_details,
        date: this.date_of_generation,
        todate: this.application_date,
      };
      this.overlay = true;
      axios
        .post("/EmployeeBiometric/addAttendance", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar(
              "#4caf50",
              "Employee Attendance Added Successfully"
            );
            this.onLoad();
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    getEmpDeatils() {
      const data = {
        ay: this.ay,
        emp_type: this.emp_type,
        designation: this.designation,
        section: this.section,
        shift:this.shift,
        emp: this.emp,
      };
      this.overlay = true;
      axios
        .post("/EmployeeBiometric/getEmpDeatils", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.inst_details = res.data.inst_details;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("EmployeeBiometric/createEmployeeAttendance")
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.ay_list = res.data.aylist), (this.ay = res.data.curreny_ay);
            this.emp_type_list = res.data.emp_type_list;
            this.designation_list = res.data.designation_list;
            this.emp_section_list = res.data.emp_section_list;
            this.emp_shift_list = res.data.emp_shift_list;
            this.emp_list = res.data.emp_list;
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.onLoad();
    this.date_of_generation = this.formatDate(this.gen_date);
    this.application_date = this.formatDate(this.date_of_application);
  },
  computed: {
    filteredItems() {
      return this.inst_details.filter((item) => {
        return (
          item.name.toLowerCase().indexOf(this.search1.toLowerCase()) > -1 ||
          item.employee_code.toLowerCase().indexOf(this.search1.toLowerCase()) >
            -1
        );
      });
    },
  },
};
</script>
<style scoped>
.mytable /deep/ thead th {
  background: #2980b9 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2980b9,
    #2980b9,
    #2980b9
  ) !important; /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2980b9,
    #2980b9,
    #2980b9
  ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #2980b9 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
input[type="date"] {
  width: 100%;
  display: inline-block;
  padding: 0.3rem;
  border: 1px solid gray;
  border-radius: 30px;
  box-sizing: border-box;
  padding-top: none !important;
  margin-top: none !important;
}
tr,
td,
th {
  border: 1px solid #ccc;
  text-align: center;
  font-size: small;
}
tr,
tbody {
  border-bottom: 1px solid #ccc;
  border: 1px solid #ccc;
  font-size: small;
}
td {
  margin: 0.3rem !important;
  padding: 0.4rem !important;
  font-size: small;
}
@media (min-width: 320px) {
  td,
  th {
    display: table-cell !important;
    font-size: small;
  }
  td + td,
  th + th {
    width: auto;
    font-size: small;
  }
}
v-simple-table {
  white-space: nowrap !important;
  text-align: center;
  font-size: small;
}
.mytable2 /deep/ thead th {
  background: #0f2027 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
</style>
